export default __webpack_public_path__ + "static/media/cherishmemories.a64aa1c4.pdf";